export default {
  name: 'templateString',

  props: {
    content: { type: String },
    data: { type: Object },
    wrapContent: { type: Boolean, default: true },
  },

  render(h) {
    return h({
      template: this.wrapContent
        ? "<div>" + this.content + "</div>"
        : this.content,
      data: () => this.data
    })
  }
}
